<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${$t('Каптча')}'`" :rules="{ required: !isTestMode }">
    <vue-recaptcha
        ref="recaptcha"
        v-model="captcha"
        :sitekey="sitekey"
        @verify="onCaptchaVerify"
        @expired="resetCaptcha" />
    <span class="text-left red--text">
      {{ errors[0] }}
    </span>
  </ValidationProvider>
</template>

<script>

  import Vue from 'vue'
  const VueRecaptcha = () => import('vue-recaptcha')

  export default {
    components: {
      VueRecaptcha
    },
    props: {

    },
    data () {
      return {
        sitekey: Vue.getCaptchaKey(),
        captcha: ''
      }
    },
    beforeDestroy () {
      const captchaElement = document.getElementById('recaptchaScript')
      if (!captchaElement || captchaElement.parentNode) {
        return
      }
      captchaElement.parentNode.removeChild(captchaElement)
    // в IE не работает код ниже
    // document.getElementById('recaptchaScript').remove()
    },
    created () {
      this.initRecaptcha()
    },
    methods: {
      initRecaptcha: function () {
        const recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('async', '')
        recaptchaScript.setAttribute('defer', '')
        recaptchaScript.id = 'recaptchaScript'
        recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${this.systemLocale}`)
        recaptchaScript.async = true
        document.head.appendChild(recaptchaScript)
      },
      // обработка результата проверки каптчи
      onCaptchaVerify: function (captcha) {
        this.captcha = captcha
        this.$emit('input', captcha)
      },
      // сброс каптчи, если с сервера пришла ошибка
      resetCaptcha: function () {
        this.$refs.recaptcha.reset()
      // console.log('reset recaptcha')
      }
    }
  }
</script>
